<div class="table-section">
  <h1 translate>{{formType}}</h1>
  <form [formGroup]="form" class="mb-4" (ngSubmit)="onSubmit($event.submitter?.id)">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>

    <div id="form-actions" class="bg-light border-bottom py-2 no-print">
      <div class="container">
        <button id="back" class="btn btn-secondary me-3" (click)="back()" ngbTooltip="back" placement="bottom"><i class="bi bi-arrow-left"></i> Back</button>
        <span class="d-inline-block" tabindex="0" [ngbTooltip]="approveTooltip" placement="bottom">
          <button id="approve" type="submit" class="btn btn-success me-3" [disabled]="!canApprove"><i class="bi bi-check-circle"></i> Approve</button>
        </span>
        <span class="d-inline-block" tabindex="0" [ngbTooltip]="canApprove ? 'Approve' : 'You cannot approve/reject your own forms'" placement="bottom">
          <button id="approveToReview" type="submit" class="btn btn-success me-3" [disabled]="!canApprove" translate><i class="bi bi-check-circle"></i> Approve to review</button>
        </span>
        <span class="d-inline-block" tabindex="0" [ngbTooltip]="rejectTooltip" placement="bottom">
          <button id="reject" type="submit" class="btn btn-warning me-3" [disabled]="!canReject"><i class="bi bi-x-circle"></i> Reject</button>
        </span>
      </div>
    </div>
  </form>
</div>